<template>
  <div class="lists">
    <div class="next" @click="Note">Next</div>
    <div class="daily">
      <span>My daily boring life</span>
      <ul>
        <li v-for="item in lists" :key="item.id">
          <img :src="item.img" alt="">
        </li>
      </ul>
    </div>
    <div class="reading">
      <span>Reading club sharing</span>
      <ul>
        <li v-for="item in lists.slice(0,5).reverse()" :key="item.id">
          <img :src="item.img" alt="">
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="sass">


</style>

<script>
export default {
  data() {
    return {
      lists: [
        {
          img: require('../assets/img/MilkCandy.svg')
        },
        {
          img: require('../assets/img/Green.svg')
        },
        {
          img: require('../assets/img/Noodle.svg')
        },
        {
          img: require('../assets/img/LilAngel.svg')
        },
        {
          img: require('../assets/img/Choco.svg')
        },
        {
          img: require('../assets/img/Stars.svg')
        },
        {
          img: require('../assets/img/CNYCandy.svg')
        },
        {
          img: require('../assets/img/Calpis.svg')
        },
      ]
    }
  },
  methods: {
    Note() {
      this.$router.push('/Note')
    },
  }
}
</script>


